import { serviceLoading } from 'common/loaderReducer';
import * as React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import { RootState } from '../../../../../store/types';
import { WidgetContainer,WidgetTitle,InlineLeft,Info2,ToolTipContainer2,IconContainer,ToolTipLabel,EmptyStateContainer,EmptyStateMessage2 } from '../styles';
import ChartDoughnut from 'components/ChartDoughnut'
import info from '../../../../../common/images/icon-info.svg';
import { GET_PROFILE_PERFORMANCE_INSIGHTS_API_REQUEST } from 'features/Dealers/Performance/state/actionTypes';
import { ProfilePerformanceActionsStats } from 'features/Dealers/Performance/state/types';
import { ILegendItem } from 'components/ChartDoughnut/types';
import Loader from 'components/Loader';
import noprofileactions from './noprofileactions.png'
import { CalculatePercentageOfTotal, numberWithCommas, GetNumberKMG } from 'features/Dealers/Performance/Widgets/utils';

const WidgetProfileActions = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const colors = ['#FF7F27','#FFAF3E','#61BF7C'];

    const rootProps = useSelector((rootState: RootState) => {
        const isRequesting = serviceLoading(rootState, [GET_PROFILE_PERFORMANCE_INSIGHTS_API_REQUEST]);
        return {
            dealerId: rootState.dealers.dealer.selectedDealer?.id,
            actionsStats: rootState.dealers.offerInsights.profilePerformanceStats?.actionsStats,
            isRequesting
        }
    }, shallowEqual);

    const totalActions: number = (rootProps.actionsStats?.website?rootProps.actionsStats?.website:0) + (rootProps.actionsStats?.drivingDirections?rootProps.actionsStats?.drivingDirections:0) + (rootProps.actionsStats?.phone?rootProps.actionsStats?.phone:0);

    return (
        <WidgetContainer>
            <InlineLeft>
            <WidgetTitle>
                Customer Actions
            </WidgetTitle>
            <IconContainer>
            <Info2>
            <img src={info}></img>
            </Info2>
            <ToolTipContainer2>
                <ToolTipLabel>
                    The most common actions that
                    customers take on your listing.
                </ToolTipLabel>
            </ToolTipContainer2>
            </IconContainer>
            </InlineLeft>
            {
                rootProps.isRequesting &&
                    <Loader/>
            }
            {
                !rootProps.isRequesting && totalActions>0 &&
                <ChartDoughnut
                    OuterRingData={GetData(rootProps.actionsStats,totalActions)}
                    OuterRingColors={colors}
                    OuterRingDataSpacer={5}
                    innerTextLine1={GetNumberKMG(totalActions)}
                    innerTextLine2={'ACTIONS'}
                    ShowLegend={true}
                    LegendItems={GetLegendItems(colors,rootProps.actionsStats)}
                    OuterRingAnimation={true}
                    LegendPosition={window.innerWidth>2200?'RIGHT':'BOTTOM'}
                />
            }
            {
                !rootProps.isRequesting && totalActions===0 &&
                <EmptyStateContainer>
                    <img src={noprofileactions}/>
                    <EmptyStateMessage2>
                        No actions have been found on your GBP Profile.
                        <br/>When customers start interacting with your 
                        business profile, you will see data about the 
                        actions taken on your profile.
                    </EmptyStateMessage2>
                </EmptyStateContainer>
            }
        </WidgetContainer>
    )
}

function GetLegendItems(colors: string[],profilePerformanceActionsStats?: ProfilePerformanceActionsStats)
{
    let legend: ILegendItem[] = [];
    if(profilePerformanceActionsStats)
    {
        legend.push({color:colors[0],label:'Visit to your website: ' + numberWithCommas((profilePerformanceActionsStats.website?profilePerformanceActionsStats.website:0).toString())});
        legend.push({color:colors[1],label:'Requests for directions: ' + numberWithCommas((profilePerformanceActionsStats.drivingDirections?profilePerformanceActionsStats.drivingDirections:0).toString())});
        legend.push({color:colors[2],label:'Phone calls: ' + numberWithCommas((profilePerformanceActionsStats.phone?profilePerformanceActionsStats.phone:0).toString())});
    }
    return legend;
}

function GetData(profilePerformanceActionsStats?: ProfilePerformanceActionsStats,totalActions?: number)
{
    let data: number[] = [];
    if(profilePerformanceActionsStats && totalActions)
    {
        data.push(CalculatePercentageOfTotal(profilePerformanceActionsStats.website?profilePerformanceActionsStats.website:0,totalActions));
        data.push(CalculatePercentageOfTotal(profilePerformanceActionsStats.drivingDirections?profilePerformanceActionsStats.drivingDirections:0,totalActions));
        data.push(CalculatePercentageOfTotal(profilePerformanceActionsStats.phone?profilePerformanceActionsStats.phone:0,totalActions));
    }
    return data;
}

export default WidgetProfileActions
